import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
// import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
// import { withRouter } from 'react-router';
// import { RegisterNewUser } from '../../actions/user.js';
import {LoginUser} from '../../actions/user.js';
// import {CheckExistingUser} from '../../actions/user.js';
// import RegisterForm from './registerform';
import LoginForm from './loginform';
import TopNav from '../includes/TopNav';
import {Helmet} from "react-helmet";
//import { getStudentPapers } from '../../actions/studentdashboard.js'
import {getUserSession, updateUserEmail} from '../../actions/user';
import {getSession1} from '../../actions/paper.js';
import { trackPage } from '../../util/analytics.js';

class ThankYou extends Component{

  constructor(props) {
    super(props);

    this.alreadyLoggedin = false;
    var paid_doc_info_str = window.localStorage.getItem('paid_doc_info');
    var paid_doc_info = {};
    if(paid_doc_info_str) {
      paid_doc_info = JSON.parse(paid_doc_info_str);
      this.state = { 'loginFailed': false, 'user': { 'email': paid_doc_info.email, 'pass': atob(paid_doc_info.pass) }}
    } else {
      this.state = {};
    }
    if(paid_doc_info.isLoggedIn){
      this.alreadyLoggedin = true;
      //this.props.dispatch(getStudentPapers()); // TODO - find a way to refresh student dashboard after payment
      this.props.history.push('/studentdashboard');
    }
    window.localStorage.removeItem('paid_doc_info');
    this.userExists = null;
  }
  
  componentDidMount() {
    trackPage('thankyou');
  }
  submitLogin = (values) => {
    this.props.dispatch(
      LoginUser(values, (body) => {
        console.log("checking body of return ", body);
        console.log("logged in successfully! ", this.props.User);
        if(body.user){
          if(body.user.loggedin){
            this.setState({'loginFailed': false});
            if(body.user.role === "student"){
              this.props.history.push('/studentdashboard');
            }else if (body.user.role === "editor") {
              this.props.history.push('/editordashboard');
            }else if (body.user.role === "admin") {
              this.props.history.push('/admindashboard');
            }
          }
        } else {
          this.setState({'loginFailed': true});
        }
      })
    );
  }
  render() {
    const useremail = (this.state.user && this.state.user.email)? this.state.user.email: '';
    const userpass = (this.state.user && this.state.user.pass)? this.state.user.pass: '';
    return (
      <div>
        <Helmet>
          <title>Thank You | Proofreading Manuscripts </title>
        </Helmet>
        <TopNav />
        <section className="thankyou">
          <div>
            <div className="banner-row">
              Order Success!
              <div className="small-banner">
                Great job! Your paper will be edited and returned to you via email and available once you login.
              </div>
              <div className="small-banner">
                New to Proofreading Manuscripts?
                <div>
                  Your account email is: {useremail} <br />
                  Your account password is: {userpass}<br />
                  <strong>Please copy and paste this information as you will need it to access your edited paper when it is ready.</strong><br />
                  The details above have also been sent to your email, but please save your password to ensure you can access your account.<br />                
                </div>
              </div>
            </div>
            {
              console.log("already rendering the component")
            }
            <div className="thanks-form-container">
              <div>
                <div className="thanks-form-lead">Already a client? Login to your dashboard below</div>
                
                  <LoginForm shouldShowGetStarted={false} onSubmit={this.submitLogin} loginFailed={this.state.loginFailed} initialValues={this.state.user}></LoginForm>
              </div>
            </div>
          </div>
        </section>
     </div>
    )
  }
}

export default connect(
  ({Paper, Modals, User})=>({Paper, Modals, User})
)(ThankYou);
//export default withRouter(ThankYou);



// WEBPACK FOOTER //
// ./src/components/steps/ThankYou.js